import styled from 'styled-components';
import { colors } from '../../../theme';

export const SectionCustom = styled.section`
  background-color: ${colors.white};
  margin: 0 auto;
  position: relative;
  width: 100%;
`;
